module.exports = __webpack_public_path__ + "img/article.af6a09c8.svg";